import React, { useState, useEffect, useRef, useMemo } from 'react';
import Button from './Button';

interface IProps {
    date: Date;
    days?: string[];
    className?: string;
    getMessages?: (date: string) => void;
    setDate: (date: Date) => void;
}

function Calendar(props: IProps) {
    const [monthName, setMonthName] = useState("");
    const date = useRef<Date | null>(null);
    const today = useRef<number>(new Date().setHours(0, 0, 0, 0));

    const setBaseDate = (m: number, y: number) => {
        const newDate = new Date(props.date.getTime()); // Kopie des aktuellen Datums
        if (m) {
            // Monat ändern (automatisch korrigiert JavaScript das Jahr bei Überlauf)
            console.log(m, newDate.getMonth(), newDate.getMonth() + m);
            newDate.setMonth(newDate.getMonth() + m);
            console.log(newDate.toISOString());
        } else if (y) {
            // Jahr ändern
            newDate.setFullYear(newDate.getFullYear() + y);
        } else {
            // Auf heute setzen
            newDate.setTime(Date.now());
        }

        props.setDate(newDate); // Neues Datum setzen
    };
    // Berechnet die Wochen des Monats
    const calculateWeek = (): string[][] => {
        const w: string[][] = [];
        for (let i = 0; i < 7; i++) {
            if (!date.current) return [];

            let className = "";
            // Grau, wenn der Tag nicht zum aktuellen Monat gehört
            if (date.current.getMonth() !== props.date.getMonth()) {
                className += "chatGray ";
            }

            // Heutiges Datum markieren
            const todayDate = new Date(today.current);
            const isToday =
                date.current.getDate() === todayDate.getDate() &&
                date.current.getMonth() === todayDate.getMonth() &&
                date.current.getFullYear() === todayDate.getFullYear();
            if (isToday) className += "today ";

            // Ausgewähltes Datum markieren
            const isSelected =
                date.current.getDate() === props.date.getDate() &&
                date.current.getMonth() === props.date.getMonth() &&
                date.current.getFullYear() === props.date.getFullYear();
            if (isSelected) className += "hl ";

            // Tage mit Nachrichten markieren
            const d = date.current.toISOString().split("T")[0];
            if (props.days?.includes(d)) {
               // console.log(d, props.days);
                className += "chatDate";
                w.push([String(date.current.getDate()), className, d]);
            } else {
                w.push([String(date.current.getDate()), className, null]);
            }
            // Zum nächsten Tag gehen
            date.current.setDate(date.current.getDate() + 1);
        }
        return w;
    };


    // Berechnet den gesamten Monat
    const calculateMonth = (): string[][][] => {
        // Zurücksetzen auf den 1. des Monats
        date.current = new Date(props.date.getFullYear(), props.date.getMonth(), 1);
        const dow = date.current.getDay(); // 0 (Sonntag) bis 6 (Samstag)
        const k = dow === 0 ? 6 : dow - 1; // Gehe zum Montag der Vorwoche

        date.current.setDate(date.current.getDate() - k);

        const days: string[][][] = [];
        while (days.length < 6) { // Maximal 6 Wochen anzeigen
            days.push(calculateWeek());
            if (date.current.getMonth() > props.date.getMonth()) break;
        }
        return days;
    };

    // Wochen berechnen (mit useMemo für Performance)
    const weeks = useMemo(() => {
        return calculateMonth();
    }, [props.date, props.days]);

    // Monatnamen setzen
    useEffect(() => {
        if (props.date) {
            setMonthName(props.date.toLocaleString('default', { month: 'long' }));
        }
    }, [props.date]);

    // Rendern eines Tages
    const renderDay = (day: string[], idx: number) => (
        <td
            key={`day_${idx}`}
            className={day[1]}
            onClick={day[2] ? () => props.getMessages(day[2]) : undefined}
        >
            {day[0]}
        </td>
    );

    // Rendern einer Woche
    const renderWeek = (week: string[][], idx: number) => (
        <tr key={`week_${idx}`}>
            {week.map(renderDay)}
        </tr>
    );

    // Rendern des Monats
    const renderMonth = () => (
        <>
            {weeks?.map(renderWeek)}
        </>
    );
    return (
        <div className={props.className}>
            <div className="month_year">
                <Button onClick={() => setBaseDate(null, -1)} label="&lt;&lt;" />
                <Button onClick={() => setBaseDate(-1, null)} label="&lt;" />
                <div onClick={() => setBaseDate(null, null)}>{monthName} {props.date.getFullYear()}</div>
                <Button onClick={() => setBaseDate(+1, null)} label="&gt;" />
                <Button onClick={() => setBaseDate(null, +1)} label="&gt;&gt;" />
                <div className="clear" />
            </div>
            <table>
                <tbody>
                    <tr>
                        <th>Mo</th><th>Di</th><th>Mi</th><th>Do</th><th>Fr</th><th>Sa</th><th>So</th>
                    </tr>
                    {weeks && renderMonth()}
                </tbody>
            </table>
        </div>
    );
}

export default Calendar;
